export enum UserRoles {
  Root = 'ROOT',
  Admin = 'ADMIN',
  Secretary = 'SECRETARY',
  Teacher = 'TEACHER',
  Parent = 'PARENT',
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
}

export enum ContractStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum ContractPaymentType {
  Register = 'REGISTER',
  Monthly = 'MONTHLY',
  Extra = 'EXTRA',
}

export enum ContractPaymentDetailType {
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  BankAccount = 'BANK_ACCOUNT',
  Iris = 'IRIS',
}

export enum LessonType {
  Normal = 1,
  Replacement = 2,
  Replaced = 3,
}

export enum LessonStatus {
  Normal = 'NORMAL',
  ToBeReplaced = 'TO_BE_REPLACED',
  Replaced = 'REPLACED',
  Canceled = 'CANCELED',
}

export enum CustomFieldType {
  Text = 'TEXT',
  Number = 'NUMBER',
  Date = 'DATE',
  SingleChoice = 'SINGLE_CHOICE',
  MultipleChoice = 'MULTIPLE_CHOICE',
}

export enum LessonRepeatTypeEnum {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Custom = 'CUSTOM',
}

export enum LessonEndTypeEnum {
  OnDate = 'ON_DATE',
  After = 'AFTER',
}

export enum GradeType {
  Lesson = 'LESSON',
  Period = 'PERIOD',
}
